import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@mantine/core';

export const Wrapper = styled.div`
  margin: auto;
  background-color: #ececec;
`;

export const Content = styled.div`
  max-width: 82.5rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 60px 20px;

  .empty-message {
    font-size: ${rem(18)};
    font-weight: 600;
  }
`;

export const PostsWrapper = styled.div<{ length: number }>`
  ${({ length }) => css`
    gap: 45px;
    ${length === 1
      ? css`
          display: flex;
          max-width: 500px;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

          @media (max-width: 640px) {
            grid-template-columns: 1fr;
          }
        `}
  `}
`;
